import api from './axios';

export async function getAchievements() {
  const { data } = await api.get('/achievements');
  return data;
}

export async function syncAchievements() {
  const { data } = await api.post('/achievements/sync');
  return data; // { newCompletedMissions, pointsAwarded, leveledUp, leveledUpLocked, unlockAvailableAt }
}

export async function getLeaderboard(limit = 20) {
  const { data } = await api.get('/achievements/leaderboard', { params: { limit } });
  return data; // { leaders: [...] }
}
